<template>
  <div>
    <FormKit
      :type="maskInput"
      v-model="value"
      label="Телефон"
      validation="required|matches:/^\+7\s\(9\d{2}\)\s\d{3}-\d{2}-\d{2}$/"
      :validation-messages="{
        required: 'Укажите телефон',
        matches: 'Некорректный номер телефона'
      }"
      validation-visibility="submit"
    />
  </div>
</template>

<script setup>
import { createInput } from '@formkit/vue'
import { ref } from 'vue';
import { maskDefinitions } from "@/components/Inputs/maskDefinitions";
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  mask: String,
  placeholder: String,
  defaultValue: String
})
const value = ref(props.defaultValue)

const emits = defineEmits(['update:modelValue'])
const maskInput = createInput(
  {
    $el: 'input',
    attrs: {
      onInput: '$handlers.customOnInput',
      value: '$_value',
      placeholder: props.placeholder
    },
  },
  {
    features: [handleInput],
  }
)

function handleInput(node) {
  node.on('created', () => {
    node.context.handlers.customOnInput = (event) => {
      const maskedValue = applyMask(event.target.value);
      node.context.node.input(maskedValue);
      event.target.value = maskedValue;
      emits('update:modelValue', maskedValue);
    }
  })
}

function applyMask(value) {
  const maskedValue = [];
  let unmaskedIndex = 0;
  let maskIndex = 0;

  while (unmaskedIndex < value.length && maskIndex < props.mask.length) {
    const maskChar = props.mask[maskIndex];
    const unmaskedChar = value[unmaskedIndex];
    const maskDefinition = maskDefinitions[maskChar];

    if (maskDefinition) {
      if (maskDefinition.escape) {
        maskIndex++;
        maskedValue.push(value[unmaskedIndex]);
        unmaskedIndex++;
      } else if (maskDefinition.pattern.test(unmaskedChar)) {
        const transformedChar = maskDefinition.transform ? maskDefinition.transform(unmaskedChar) : unmaskedChar;
        maskedValue.push(transformedChar);
        unmaskedIndex++;
      } else {
        break;
      }
    } else {
      maskedValue.push(maskChar);
      if (maskChar === unmaskedChar) {
        unmaskedIndex++;
      }
    }
    maskIndex++;
  }
  return maskedValue.join('');
}
</script>
